import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  Button,
  Dropdown,
  Icon,
  SplitButton,
  Tooltip,
} from '@studio/legacy-components';
import { fromNow } from 'next/lib/date';
import { MOBILE_PUBLISHING, selectFeature } from 'next/entities/features';
import { DropdownListHeading, OptionList, TooltipLabel } from './styled';

export const PublishingActions = ({
  published,
  updatedAt,
  disabled,
  hasChanges,
  onConfirmPublish,
  onConfirmDiscardChanges,
  onConfirmUnpublish,
  hasMobilePublishing = true,
}) => {
  const label = !hasMobilePublishing ? (
    <TooltipLabel>
      Publishing a mobile Flow is not available while in a trial. Contact your
      Appcues sales rep to talk about upgrading to a paid mobile plan.
    </TooltipLabel>
  ) : (
    'Contact a team admin or publisher to publish'
  );
  return (
    <>
      {!published && (
        <Tooltip disabled={!disabled} label={label} placement="bottom" wrapped>
          <Button
            disabled={disabled}
            kind="primary"
            onClick={onConfirmPublish}
            aria-label="Click to Publish"
          >
            Publish
          </Button>
        </Tooltip>
      )}
      {hasChanges && published && (
        <Tooltip disabled={!disabled} label={label} placement="bottom">
          <SplitButton kind="positive" disabled={disabled}>
            <Button
              aria-label="click to push changes"
              disabled={disabled}
              onClick={onConfirmPublish}
            >
              Push changes
            </Button>
            <Dropdown
              aria-label="Open change actions"
              forwardedAs={Button}
              disabled={disabled}
              attachment={
                <>
                  <DropdownListHeading bold>
                    Updated {fromNow(updatedAt)}
                  </DropdownListHeading>
                  <OptionList
                    options={[
                      {
                        label: 'Push changes',
                        onClick: onConfirmPublish,
                      },
                      {
                        label: 'Discard changes',
                        onClick: onConfirmDiscardChanges,
                      },
                      {
                        label: `Unpublish Experience`,
                        onClick: onConfirmUnpublish,
                      },
                    ]}
                  />
                </>
              }
            >
              <Icon icon="chevron-down" />
            </Dropdown>
          </SplitButton>
        </Tooltip>
      )}
      {!hasChanges && published && (
        <Button
          disabled={disabled}
          kind="secondary"
          onClick={onConfirmUnpublish}
          aria-label="Click to Unpublish"
        >
          Unpublish
        </Button>
      )}
    </>
  );
};

PublishingActions.propTypes = {
  published: PropTypes.bool,
  updatedAt: PropTypes.number,
  disabled: PropTypes.bool,
  hasChanges: PropTypes.bool,
  onConfirmPublish: PropTypes.func,
  onConfirmDiscardChanges: PropTypes.func,
  onConfirmUnpublish: PropTypes.func,
  hasMobilePublishing: PropTypes.bool,
};

const mapStateToProps = state => {
  const hasMobilePublishing = selectFeature(state, MOBILE_PUBLISHING);

  return {
    hasMobilePublishing,
  };
};

export default connect(mapStateToProps)(PublishingActions);
